import { bridge, canIUse, xenv, query, is, compareVersion } from '@didi/webx-js'

export const hideCustomNativeNavBar = () => {
  const _pos = query().jingang && is('android')
  if (_pos) {
    return new Promise(resolve => {
      bridge.getSystemInfo({}, res => {
        resolve(compareVersion(res.appversion, '6.7.20') < 0)
      })
    })
  }
  return Promise.resolve(false)
}

export const setNativeNavBar = async options => {
  const hideCustomNavBar = await hideCustomNativeNavBar()
  if (hideCustomNavBar) return
  const navihidden = options?.navihidden ? 1 : 0
  const navianimated = options?.navianimated ? 1 : 0
  const bgcolor = options?.bgcolor
  const titlecolor = options?.titlecolor
  const navstyle = options?.navstyle
  const shadowhidden = options?.shadowhidden ? 1 : 0
  if (['passenger', 'hypassenger'].includes(xenv()) && canIUse('bridge')) {
    bridge?.updateNaviView?.({
      navihidden,
      navianimated,
      shadowhidden,
      navstyle,
      ...(bgcolor ? { bgcolor } : {}),
      ...(titlecolor ? { titlecolor } : {}),
    })
    navihidden
      ? bridge?.hideNativeBar?.({
          animated: 0,
        })
      : bridge?.showNativeBar?.({
          animated: 0,
        })
  }
}
